// extracted by mini-css-extract-plugin
export default {"collapsibleContainer":"collapsible_collapsibleContainer__386MG","collapsibleContent":"collapsible_collapsibleContent__y1VYL"};